import { IItemClickParams, IMultiSuggestResult } from '@cian/geosuggest-widget';
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { FirstStepForm } from 'shared/components/FirstStepForm';
import { useAppDispatch } from 'shared/hooks';
import { selectAddressErrorMessage, selectAddressValidateStatus } from 'shared/selectors/address';
import { getMultiSuggest } from 'shared/services/getMultiSuggest';
import { setErrorMessage, setPhone } from 'shared/slices';
import { validateAddress } from 'shared/thunks';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const FirstStepFormContainer: React.FC = () => {
  const { config } = useApplicationContext();

  const apiSuggest = String(config.get<string>('info-pik-arenda-frontend.YandexSuggestApiKey'));

  const api = String(config.get<string>('info-pik-arenda-frontend.YandexApiKey'));

  const [address, setAddress] = useState('');

  const [phoneValue, setPhoneValue] = useState('');

  const [phoneError, setPhoneError] = useState('');

  const addressStatus = useSelector(selectAddressValidateStatus);

  const addressErrorMessage = useSelector(selectAddressErrorMessage);

  const dispatch = useAppDispatch();

  const [suggest, setSuggest] = useState<IMultiSuggestResult>({ sortOrder: [], suggestions: {} });

  const handlePhoneValue = useCallback((e: string) => {
    setPhoneValue(e);

    setPhoneError('');
  }, []);

  const handleAddressValue = useCallback(
    async (value: string) => {
      setAddress(value);
      if (value.length > 2) {
        const newSuggest = await getMultiSuggest({
          yandex: {
            value,
            suggestApiKey: apiSuggest,
            apiKey: api,
          },
        });

        setSuggest(newSuggest);
      }
    },
    [api, apiSuggest],
  );

  const handleItemGeoClick = useCallback(
    (value: IItemClickParams) => {
      setAddress(value.title);

      dispatch(setErrorMessage());
    },
    [dispatch],
  );

  const handleBtnNext = useCallback(async () => {
    if (phoneValue.length < 10) {
      setPhoneError('Введите номер телефона');
    }

    if (address.length === 0) {
      dispatch(setErrorMessage('Введите адрес'));
    }

    if (phoneValue.length === 10 && address.length > 2) {
      dispatch(setPhone(phoneValue));

      await dispatch(validateAddress({ address }));
    }
  }, [address, dispatch, phoneValue]);

  return (
    <FirstStepForm
      address={address}
      addressErrorMessage={addressErrorMessage}
      addressStatus={addressStatus}
      phoneErrorMessage={phoneError}
      suggest={suggest}
      onAddressValue={handleAddressValue}
      onBtnNext={handleBtnNext}
      onItemGeoClick={handleItemGeoClick}
      onPhoneValue={handlePhoneValue}
    />
  );
};
